import axios from 'axios';
// create an instance of axios

// TMDB base url to append at the begging of the endpoint for the api calls
const instance = axios.create({ baseURL: "https://api.themoviedb.org/3", });

export default instance;

